/**
 * Disparo de conversão para Meta Pixel e Google Ads.
 *
 * A INSTALAÇÃO dos scripts fica em gatsby-ssr.js (só entram no HTML se os IDs
 * existirem no ambiente). Este módulo só DISPARA o evento, e por isso não
 * conhece nenhum ID.
 *
 * Chamado exclusivamente depois de o servidor confirmar a gravação da inscrição.
 * Disparar no clique do botão contaria como conversão quem clicou e falhou na
 * validação, quem desistiu e quem levou erro de rede — inflando o número e
 * fazendo o algoritmo das campanhas otimizar para o público errado.
 *
 * Idempotente por carregamento de página: um duplo clique que emendasse dois
 * envios não pode virar duas conversões.
 */

let jaDisparou = false

export function conversaoInscricao() {
  if (typeof window === 'undefined' || jaDisparou) return
  jaDisparou = true

  // Meta Pixel. `fbq` só existe se ROTA_META_PIXEL_ID estiver configurado.
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', { content_name: 'Rota da Eficiência' })
  }

  // Google. `gtag` só existe se ROTA_GOOGLE_TAG_ID estiver configurado.
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'generate_lead', { event_category: 'inscricao', value: 1 })
  }
}

/** Só para teste: permite disparar de novo dentro do mesmo carregamento. */
export function reiniciarRastreamento() {
  jaDisparou = false
}
